import { render, staticRenderFns } from "./AudioUpload.vue?vue&type=template&id=7c380ef4&scoped=true"
import script from "./AudioUpload.vue?vue&type=script&lang=ts"
export * from "./AudioUpload.vue?vue&type=script&lang=ts"
import style0 from "./AudioUpload.vue?vue&type=style&index=0&id=7c380ef4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c380ef4",
  null
  
)

export default component.exports